// Tests for shallow comparison between two objects
export default function shallowEqual(a, b) {
	if (a === b) {
		return true
	}
	if (typeof a !== 'object' || !a || typeof b !== 'object' || !b) {
		return false
	}

	const aKeys = Object.keys(a)
	const bKeys = Object.keys(b)
	if (aKeys.length  !== bKeys.length) {
		return false
	}

	const bHasProperty = Object.prototype.hasOwnProperty.bind(b)
	for (let i = 0; i < aKeys.length; i++) {
		const key = aKeys[i]
		if (!bHasProperty(key) || a[key] !== b[key]) {
			return false
		}
	}

	return true
}
